import React, { useState }  from "react";
import { useDispatch, useSelector } from "react-redux";
   import { useMediaQuery } from "react-responsive";
   import { FaFacebook,   FaLinkedin, FaMapMarkerAlt, FaPhone, FaEnvelope, FaInstagram } from "react-icons/fa";
  import {FaXTwitter} from "react-icons/fa6" 
   import { FaChevronRight } from "react-icons/fa";
    import Container from "./Container";
 import "../styles/footer.css"
 import { subscribeNewsletter } from "../features/user/userSlice";
     import { BsSendFill } from "react-icons/bs";

const Footer = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { message } = useSelector((state) => state.user || { message: null });
  const isDesktop = useMediaQuery({ minWidth: 768 });

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      dispatch(subscribeNewsletter(email)); // Dispatch the action with the email
      setEmail(""); // Optionally clear the input after submission
    }
  }; 

  return (
    <>
    
      <Container class1="footer-wrapper">
        <div className="newsletter-container">
               <div className="newsletter-el-1">
              <div className="footer-top-data d-flex gap-3 align-items-center">
              <BsSendFill className="send-icon"/>
                <h2 className="mb-0 text-white footer-one-title">Sign Up for Newsletter</h2>
              </div>
            </div>
            <div className="newsletter-el-2">
              <div className="input-group">
              <form onSubmit={handleSubscribe} className="input-group">
                <input
                  type="email"
                  className="form-control py-1"
                  placeholder="Your Email Address"
                  aria-label="Your Email Address"
                  aria-describedby="basic-addon2"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="input-group-text p-2" id="basic-addon2">
                  Subscribe
                </button>
              </form>
              {message && <div className="error-message text-danger mt-2">{message}</div>}

              </div>
            </div>
       
        </div>
  <div className="footer-content">
    <div className="footer-left">
      <div className="footer-image-container">
 
       <h2>Q<span>en</span><span>train</span></h2>
      </div>
      <p className="tagline">At Qentrain Solutions Ltd, we believe in practical, cost-effective solutions that drive business success.</p>
      <div className="social-icons">
              <a href="#" aria-label="Facebook"><FaFacebook /></a>
              <a href="#" aria-label="Twitter"><FaXTwitter /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="#" aria-label="LinkedIn"><FaInstagram /></a>

            </div>
    </div>
   
      <div className="quick-links">
        <h2>Quick Links</h2>
        <ul className="nav-list">
  <li><FaChevronRight className="list-arrow" /> About Us</li>
  <li><FaChevronRight className="list-arrow" /> Courses</li>
  <li><FaChevronRight className="list-arrow" /> FAQ</li>
  <li><FaChevronRight className="list-arrow" /> Contact Us</li>
</ul>
      </div>
      <div className="our-services">
        <h2>Our Services</h2>
        
        <ul className="service-list">
    <li><FaChevronRight className="list-arrow" /> ISO Certification Training</li>
    <li><FaChevronRight className="list-arrow" /> Food Safety Consultancy</li>
    <li><FaChevronRight className="list-arrow" /> Product Development</li>
    <li><FaChevronRight className="list-arrow" /> Process Improvement</li>
  </ul>
      </div>

 
    <div className="footer-right">
      <h2>Contact Us</h2>
 
    <div className="contact-info">
              <p><FaMapMarkerAlt /> Ebenezer 179-01001, Kalimoni</p>
              <p><FaPhone /> +254-720350903</p>
              <p><FaEnvelope /> qentrainsolutions@gmail.com</p>
            </div>

    </div>
  </div>
  <div className="footer-bottom">

    <p>Copyright Qentrain © 2025. All rights reserved.</p>
  </div>
</Container>

    </>
  );
  };

export default Footer;